import type { ReactNode } from 'react';
import './hint.css';

/**
 * A small "?" badge that shows a plain-language explanation on hover or
 * keyboard focus. The text is also in a `title` attribute and the badge's
 * accessible name, so touch and assistive-technology users get it too.
 */
export function Hint({ text }: { text: string }) {
  return (
    <span className="hint" tabIndex={0} role="note" aria-label={text} title={text}>
      ?
      <span className="hint-bubble" aria-hidden="true">
        {text}
      </span>
    </span>
  );
}

/**
 * Label + optional hint + control, matching the `label.field` pattern used
 * across the app. Renders a real <label>, so clicking the label still focuses
 * the control inside.
 */
export function Field({
  label,
  hint,
  className,
  children,
}: {
  label: string;
  hint?: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <label className={className === undefined ? 'field' : `field ${className}`}>
      <span className="field-label">
        {label}
        {hint !== undefined && <Hint text={hint} />}
      </span>
      {children}
    </label>
  );
}
